import React, { useContext, useState, useEffect } from 'react';
import { AppBar, Toolbar, Button, IconButton } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import { TeamPicker } from './Pickers/TeamPicker';
import { SnackbarProvider } from 'notistack';
import { useHistory } from 'react-router-dom';
import KeycloakService from 'services/KeycloakService';
import NotificationModal from './Notifications';
import { Modal } from '@mui/material';
import NotificationsAPI from 'api/NotificationsAPI';

const Header: React.FC = () => {
  const history = useHistory();
  const addClass = () => {
    document.getElementById('MainApp')?.classList.toggle('SideNavBar');
  };

  const { cur_user } = useContext(GlobalContext);
  const [ profileModal, setProfileModal ] = useState(false);
  const [ notificationModal, setNotificationModal ] = useState(false);
  const [ customer, setCustomer ] = useState<any>({ isLoading: true, data: {} });
  const [ isTrialing, setIsTrialing ] = useState({ isLoading: true, data: false });
  const [ reload, setReload ] = useState(false);
  const [ noteTab, setNoteTab ] = useState<string>('All');
  const [ notifications, setNotifications ] = useState([]);
  const [ userNotes, setUserNotes ] = useState([]);
  const [ systemNotes, setSystemNotes ] = useState([]);
  const [ hasNew, setHasNew ] = useState(true);

  const getMatchedCus = () => {
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user?.selected_team?.name) {
          setCustomer({ isLoading: false, data: cus });
        }
      });
    }
  };

  const validateTrialing = (cus: any) => {
    cus?.data?.subscriptions?.data?.map((sub: any) => {
      if (sub.status === 'trialing') {
        setIsTrialing({ isLoading: false, data: true });
      } else {
        setIsTrialing({ isLoading: false, data: false });
      }
    });
  };

  useEffect(() => {
    getMatchedCus();
  }, [ cur_user.selected_team ]);

  useEffect(() => {
    validateTrialing(customer);
  }, [ customer ]);

  const toggleProfileModal = () => {
    setProfileModal(!profileModal);
  };

  const toggleNotificationModal = () => {
    setNotificationModal(false);
  };

  const handleHomeRedirect = () => {
    history.push('/');
  };

  const getNotifications = async() => {
    const req = {
      query: {
        $or: [
          {
            userId: cur_user.basics?.id,
            $or: [
              { groupId: cur_user.selected_team?.id },
              { type: 'invite' }
            ]
          },
          {
            userId: cur_user.basics?.email,
            $or: [
              { groupId: cur_user.selected_team?.id },
              { type: 'invite' }
            ]
          }
        ]
      }
    };
    const resp = await NotificationsAPI.searchNotifications(req);
    if (resp?.success) {
      setNotifications(resp?.result);
      // Categorize notifications based on the 'system' key
      const systemNotifications = resp.result.filter((note: any) => note.system === true);
      const userNotifications = resp.result.filter((note: any) => !note.system);

      // Update state
      setSystemNotes(systemNotifications);
      setUserNotes(userNotifications);
    } else if (resp) {
      setNotifications([]);
    }
  };

  const handleClick = async(note: any) => {
    if (note.status === 'unread') {
      const body = note;
      body.status = 'read';
      const res = await NotificationsAPI.updateNotification(body);
      if (res?.success) {
        setReload(!reload);
      }
    }
  };

  const deleteNotification = async(id: string) => {
    await NotificationsAPI.deleteNotification(id);
    setReload(!reload);
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {
    getNotifications();
  }, [ reload ]);

  useEffect(() => {
    getNotifications();
  }, [ cur_user.selected_team ]);

  return <>
    <AppBar position='fixed' className='Top-Header'>
      <Toolbar>
        <div className='Logo'>
          <IconButton
            edge='start'
            className='Toggle-menu'
            color='inherit'
            aria-label='menu'
            onClick={addClass}
            size='large'>
            <Menu />
          </IconButton>
          <svg style={{ cursor: 'pointer' }} onClick={handleHomeRedirect} xmlns='http://www.w3.org/2000/svg' width='39' height='40' viewBox='0 0 39 40' fill='none'>
            <g clipPath='url(#clip0_1243_8307)'>
              <path d='M36.085 18.3908C36.8453 18.2211 37.5171 17.8191 38.0249 17.2634C39.3671 15.7935 39.3134 13.5242 37.9045 12.1167C37.4286 11.6408 36.8235 11.2925 36.1488 11.1286C35.477 10.9661 34.6804 11.0154 33.8185 10.8268C32.559 10.5511 31.4055 9.917 30.4928 9.00432C29.5105 8.02344 28.8546 6.76542 28.6152 5.40003C28.4832 4.64696 28.5325 3.77781 28.2916 3.05231C28.103 2.48207 27.7794 1.97277 27.3601 1.56213C25.9004 0.134349 23.5614 0.147408 22.1176 1.5926C20.7058 3.00443 20.6565 5.2825 22.0088 6.75091C22.3686 7.14268 22.8112 7.4561 23.3089 7.66504C24.284 8.07568 24.6932 7.92767 25.6494 8.05681C26.2022 8.13081 26.7463 8.27301 27.2643 8.4805C27.8186 8.70251 27.9695 8.78522 28.4425 9.09428C29.3204 9.66742 30.0561 10.4408 30.5871 11.3477C31.1719 12.3489 31.5071 13.5111 31.5071 14.7517C31.5071 16.6061 30.7583 18.2878 29.5453 19.5096C28.576 20.4875 27.3079 21.1695 25.8902 21.4104C25.2155 21.525 24.4799 21.4684 23.8182 21.6382C23.1638 21.8065 22.579 22.1489 22.1162 22.6118C20.6608 24.0672 20.6608 26.4279 22.1162 27.8833C23.5164 29.2835 25.7712 29.3459 27.2426 28.0226C27.7243 27.5902 28.0914 27.033 28.2974 26.4033C28.563 25.5878 28.4629 25.1989 28.5688 24.3762C28.7647 22.8599 29.4626 21.5003 30.4914 20.4716C31.5404 19.4225 32.9319 18.7173 34.4845 18.5374C35.1287 18.4634 35.461 18.5287 36.0835 18.3894L36.085 18.3908Z' fill='url(#paint0_linear_1243_8307)'/>
              <path d='M17.8908 3.41404C17.721 2.65372 17.3191 1.98045 16.7634 1.47405C15.2935 0.133329 13.0241 0.185565 11.6167 1.59449C11.1407 2.07042 10.7925 2.67403 10.6285 3.3502C10.466 4.02201 10.5153 4.81861 10.3253 5.68051C10.0496 6.93997 9.41548 8.09352 8.5028 9.00475C7.52193 9.98708 6.26391 10.6429 4.89852 10.8823C4.14545 11.0144 3.2763 10.9651 2.5508 11.2059C1.98056 11.3945 1.47271 11.7181 1.06207 12.1375C-0.365712 13.5972 -0.352653 15.9376 1.09254 17.3814C2.50437 18.7932 4.78244 18.8425 6.25085 17.4902C6.64262 17.1304 6.95604 16.6878 7.16498 16.1901C7.57561 15.215 7.42761 14.8073 7.55675 13.8482C7.63075 13.2954 7.77295 12.7512 7.98044 12.2332C8.20245 11.6789 8.28515 11.528 8.59567 11.055C9.16881 10.1772 9.94075 9.4415 10.8491 8.91043C11.8488 8.32568 13.0125 7.9905 14.2531 7.9905C16.1089 7.9905 17.7892 8.73922 19.011 9.95225C19.9889 10.923 20.6709 12.1897 20.9118 13.6073C21.0264 14.282 20.9684 15.0162 21.1396 15.6794C21.3079 16.3338 21.6503 16.9185 22.1132 17.3814C23.5685 18.8367 25.9293 18.8367 27.3847 17.3814C28.84 15.926 28.8473 13.7263 27.524 12.255C27.0916 11.7733 26.5344 11.4062 25.9047 11.2016C25.0892 10.936 24.7003 11.0362 23.8776 10.9288C22.3613 10.7329 21.0017 10.035 19.973 9.0062C18.9239 7.95713 18.2187 6.56417 18.0388 5.01305C17.9648 4.3688 18.0301 4.03652 17.8908 3.41404Z' fill='url(#paint1_linear_1243_8307)'/>
              <path fillRule='evenodd' clipRule='evenodd' d='M21.1092 36.5864C21.279 37.3467 21.6809 38.0185 22.2366 38.5264C23.7065 39.8671 25.9759 39.8149 27.3833 38.406C27.8593 37.93 28.2075 37.3264 28.37 36.6488C28.5325 35.977 28.4832 35.1818 28.6718 34.3185C28.9475 33.059 29.5816 31.9055 30.4943 30.9943C31.4766 30.0119 32.7332 29.3561 34.0986 29.1167C34.8516 28.9846 35.7208 29.034 36.4463 28.7931C37.0165 28.6045 37.5244 28.2809 37.935 27.8615C39.3628 26.4018 39.3497 24.0614 37.9045 22.6176C36.4927 21.2058 34.2146 21.1565 32.7462 22.5088C32.3545 22.8686 32.041 23.3112 31.8321 23.8089C31.4215 24.7854 31.5695 25.1917 31.4403 26.1494C31.3663 26.7022 31.2241 27.2463 31.0166 27.7643C30.7946 28.3186 30.7119 28.4695 30.4029 28.9425C29.8283 29.8204 29.0563 30.5561 28.1495 31.0871C27.1483 31.6719 25.986 32.0071 24.7454 32.0071C22.8896 32.0071 21.2093 31.2583 19.9876 30.0453C19.0096 29.0746 18.3276 27.8079 18.0868 26.3902C17.9721 25.7155 18.0287 24.9813 17.859 24.3182C17.6906 23.6638 17.3482 23.079 16.8853 22.6162C15.43 21.1608 13.0692 21.1608 11.6139 22.6162C10.2136 24.0164 10.1512 26.2712 11.4746 27.7426C11.907 28.2243 12.4641 28.5914 13.0939 28.796C13.9093 29.0615 14.2982 28.9614 15.1209 29.0688C16.6372 29.2632 17.9968 29.9626 19.0256 30.9914C20.0746 32.0404 20.7798 33.4319 20.9598 34.9845C21.0338 35.6287 20.9685 35.961 21.1078 36.5835L21.1092 36.5864Z' fill='url(#paint2_linear_1243_8307)'/>
              <path fillRule='evenodd' clipRule='evenodd' d='M2.91361 21.6092C2.15329 21.7789 1.48148 22.1809 0.973626 22.7366C-0.367098 24.2065 -0.314862 26.4758 1.09406 27.8833C1.56999 28.3592 2.1736 28.7075 2.84977 28.8714C3.52158 29.0339 4.31818 28.9846 5.18008 29.1747C6.43955 29.4504 7.59309 30.0845 8.50577 30.9971C9.4881 31.978 10.144 33.236 10.3834 34.6014C10.5154 35.3545 10.4661 36.2236 10.7069 36.9491C10.8956 37.5194 11.2191 38.0287 11.6385 38.4379C13.0982 39.8657 15.4372 39.8526 16.8824 38.4089C18.2942 36.997 18.3436 34.719 16.9912 33.2505C16.6314 32.8588 16.1888 32.5454 15.6911 32.3364C14.7161 31.9258 14.3083 32.0738 13.3507 31.9446C12.7978 31.8706 12.2537 31.7284 11.7357 31.521C11.1814 31.2989 11.0305 31.2162 10.5575 30.9072C9.67963 30.334 8.94397 29.5606 8.41291 28.6538C7.82815 27.6526 7.49297 26.4903 7.49297 25.2497C7.49297 23.3953 8.24169 21.7136 9.45473 20.4919C10.4254 19.5139 11.6922 18.832 13.1098 18.5911C13.7845 18.4765 14.5202 18.5345 15.1818 18.3633C15.8362 18.195 16.421 17.8525 16.8839 17.3897C18.3392 15.9343 18.3392 13.5735 16.8839 12.1182C15.4836 10.718 13.2288 10.6556 11.7575 11.9803C11.2757 12.4127 10.9086 12.9699 10.704 13.5996C10.4385 14.4151 10.5386 14.804 10.4327 15.6267C10.2368 17.143 9.53889 18.5026 8.51013 19.5313C7.46105 20.5804 6.06954 21.2856 4.51697 21.4655C3.87273 21.5395 3.54045 21.4742 2.91797 21.6121L2.91361 21.6092Z' fill='url(#paint3_linear_1243_8307)'/>
            </g>
            <defs>
              <linearGradient id='paint0_linear_1243_8307' x1='30.011' y1='0.499939' x2='30.011' y2='28.9757' gradientUnits='userSpaceOnUse'>
                <stop offset='0.0885417' stopColor='#4CC9F0'/>
                <stop offset='0.630208' stopColor='#4895EF'/>
                <stop offset='1' stopColor='#4361EE'/>
              </linearGradient>
              <linearGradient id='paint1_linear_1243_8307' x1='14.2485' y1='0.502136' x2='14.2485' y2='18.4732' gradientUnits='userSpaceOnUse'>
                <stop offset='0.0885417' stopColor='#4CC9F0'/>
                <stop offset='0.630208' stopColor='#4895EF'/>
                <stop offset='1' stopColor='#4361EE'/>
              </linearGradient>
              <linearGradient id='paint2_linear_1243_8307' x1='24.7593' y1='21.5247' x2='24.7593' y2='39.4983' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#4895EF'/>
                <stop offset='0.489583' stopColor='#4361EE'/>
                <stop offset='1' stopColor='#3F37C9'/>
              </linearGradient>
              <linearGradient id='paint3_linear_1243_8307' x1='8.98854' y1='11.026' x2='8.98854' y2='39.5002' gradientUnits='userSpaceOnUse'>
                <stop offset='0.161458' stopColor='#4895EF'/>
                <stop offset='0.645833' stopColor='#4361EE'/>
                <stop offset='1' stopColor='#3F37C9'/>
              </linearGradient>
              <clipPath id='clip0_1243_8307'>
                <rect width='39' height='39' fill='white' transform='translate(0 0.5)'/>
              </clipPath>
            </defs>
          </svg>
          <svg xmlns='http://www.w3.org/2000/svg' width='63' height='21' viewBox='0 0 63 21' fill='none'>
            <path d='M0.44812 20.0715V0.123474H8.43513C9.90267 0.123474 11.1267 0.341007 12.1072 0.776072C13.0877 1.21114 13.8247 1.81503 14.3182 2.58776C14.8118 3.35399 15.0585 4.23711 15.0585 5.23711C15.0585 6.01633 14.9027 6.7014 14.591 7.2923C14.2793 7.87672 13.8507 8.35724 13.3053 8.73386C12.7663 9.10399 12.1494 9.36698 11.4546 9.52282V9.71763C12.2144 9.7501 12.9254 9.96438 13.5877 10.3605C14.2566 10.7566 14.7988 11.3118 15.2144 12.0261C15.6299 12.7339 15.8377 13.578 15.8377 14.5585C15.8377 15.617 15.5747 16.5618 15.0488 17.393C14.5293 18.2176 13.7598 18.8702 12.7403 19.3507C11.7208 19.8313 10.4644 20.0715 8.97085 20.0715H0.44812ZM4.66565 16.6235H8.10396C9.27929 16.6235 10.1364 16.3994 10.6754 15.9514C11.2144 15.4969 11.4838 14.893 11.4838 14.1397C11.4838 13.5878 11.3507 13.1007 11.0845 12.6787C10.8183 12.2566 10.4384 11.9254 9.94487 11.6852C9.45786 11.4449 8.87669 11.3248 8.20137 11.3248H4.66565V16.6235ZM4.66565 8.47088H7.79228C8.3702 8.47088 8.88319 8.37023 9.33124 8.16893C9.78578 7.96114 10.1429 7.66893 10.4027 7.2923C10.6689 6.91568 10.802 6.46438 10.802 5.93841C10.802 5.21763 10.5455 4.63646 10.0325 4.1949C9.52604 3.75334 8.80526 3.53256 7.8702 3.53256H4.66565V8.47088Z' fill='#EFF1F6'/>
            <path d='M24.171 0.123474V20.0715H19.9535V0.123474H24.171Z' fill='#EFF1F6'/>
            <path d='M28.2527 3.60075V0.123474H44.6358V3.60075H38.5286V20.0715H34.3598V3.60075H28.2527Z' fill='#EFF1F6'/>
            <path d='M48.7053 20.0715V0.123474H62.1468V3.60075H52.9228V8.35399H61.4553V11.8313H52.9228V16.5943H62.1858V20.0715H48.7053Z' fill='#EFF1F6'/>
          </svg>
        </div>
        <ul>
          {cur_user?.selected_team?.attributes?.team_admin?.includes(cur_user?.basics?.email) && (
            <li className='plan-cta'>
              <Link to={{
                pathname: '/profile',
                state: {
                  linkTab: 'Plans',
                  team: cur_user.selected_team
                }
              }}
              >
                <div className='plan-cta-btn'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_6040_594)'>
                      <path d='M3.75 18.3334V14.1667M3.75 5.83335V1.66669M1.66666 3.75002H5.83333M1.66666 16.25H5.83333M10.8333 2.50002L9.38818 6.25741C9.15317 6.86843 9.03567 7.17394 8.85294 7.43093C8.69099 7.65869 8.492 7.85768 8.26424 8.01963C8.00725 8.20236 7.70174 8.31986 7.09071 8.55487L3.33333 10L7.09072 11.4452C7.70174 11.6802 8.00725 11.7977 8.26424 11.9804C8.492 12.1424 8.69099 12.3414 8.85294 12.5691C9.03567 12.8261 9.15317 13.1316 9.38818 13.7426L10.8333 17.5L12.2785 13.7426C12.5135 13.1316 12.631 12.8261 12.8137 12.5691C12.9757 12.3414 13.1747 12.1424 13.4024 11.9804C13.6594 11.7977 13.9649 11.6802 14.5759 11.4452L18.3333 10L14.5759 8.55487C13.9649 8.31986 13.6594 8.20236 13.4024 8.01963C13.1747 7.85768 12.9757 7.65869 12.8137 7.43093C12.631 7.17394 12.5135 6.86843 12.2785 6.2574L10.8333 2.50002Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </g>
                    <defs>
                      <clipPath id='clip0_6040_594'>
                        <rect width='20' height='20' fill='white'/>
                      </clipPath>
                    </defs>
                  </svg>
                  <div className='plan-cta-text-padding'>
                    {!isTrialing.isLoading && isTrialing.data && (
                      <div className='plan-cta-text-style'>
                      Upgrade
                      </div>
                    )}
                    {!isTrialing.isLoading && !isTrialing.data && !cur_user?.basics?.attributes?.bite_pro_trial_used?.includes('true') && (
                      <div className='plan-cta-text-style'>
                      Start FREE Trial
                      </div>
                    )}
                    {
                      !isTrialing.isLoading &&
                    !isTrialing.data &&
                    cur_user?.basics?.attributes?.bite_pro_trial_used?.includes('true') &&
                    !isTrialing.data &&
                    (
                      <div className='plan-cta-text-style'>
                        Get more seats
                      </div>
                    )}
                    {
                      !isTrialing.isLoading &&
                    !isTrialing.data &&
                    cur_user?.basics?.attributes?.bite_pro_trial_used?.includes('true') &&
                    isTrialing.data &&
                    (
                      <div className='plan-cta-text-style'>
                        Start Plan
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            </li>
          )}
          <li className='home-page-notify'>
            <div className='home-page-notify-actions' onClick={() => setNotificationModal(true)}>
              <div className='home-page-notify-actions-nav'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M7.79514 17.5C8.38275 18.0186 9.15462 18.3333 10 18.3333C10.8454 18.3333 11.6172 18.0186 12.2048 17.5M15 6.66666C15 5.34057 14.4732 4.0688 13.5355 3.13112C12.5978 2.19344 11.3261 1.66666 10 1.66666C8.67391 1.66666 7.40214 2.19344 6.46446 3.13112C5.52678 4.0688 5 5.34057 5 6.66666C5 9.24181 4.35039 11.005 3.62472 12.1712C3.0126 13.1549 2.70654 13.6467 2.71777 13.784C2.73019 13.9359 2.76238 13.9938 2.88481 14.0846C2.99538 14.1667 3.49382 14.1667 4.49071 14.1667H15.5093C16.5062 14.1667 17.0046 14.1667 17.1152 14.0846C17.2376 13.9938 17.2698 13.9359 17.2822 13.784C17.2934 13.6467 16.9874 13.1549 16.3753 12.1712C15.6496 11.005 15 9.24181 15 6.66666Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              {hasNew && (
                <div className='absolute top-0 right-0 w-2.5 h-2.5 bg-yellow-500 rounded-full'></div>
              )}
            </div>
            <Modal
              open={notificationModal}
              onClose={() => toggleNotificationModal()}>
              <NotificationModal
                noteTab={noteTab}
                setNoteTab={setNoteTab}
                handleClose={toggleNotificationModal}
                notifications={noteTab === 'All' ? notifications : noteTab === 'User' ? userNotes : systemNotes}
                handleClick={handleClick}
                deleteNotification={deleteNotification}
              />
            </Modal>
            {!profileModal ? (
              <>
                <Button color='inherit' className='Header-Profile' onClick={toggleProfileModal}>
                  <div className='profile-icon'>
                    {cur_user.basics?.firstName[0]}{cur_user.basics?.lastName[0]}
                  </div>
                  <div className='profile-metadata'>
                    <div className='profile-name'>
                      {cur_user.basics?.firstName} {cur_user.basics?.lastName}
                    </div>
                    <div className='profile-email'>
                      {cur_user.basics?.email}
                    </div>
                  </div>
                  <div className='profile-open'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='13' height='8' viewBox='0 0 13 8' fill='none'>
                      <path d='M10.484 0.842131C10.6712 0.6433 10.9051 0.543884 11.1858 0.543884C11.4665 0.543884 11.7004 0.6433 11.8875 0.842131C12.0864 1.02926 12.1858 1.26318 12.1858 1.54388C12.1858 1.82459 12.0864 2.0585 11.8875 2.24564L6.99281 7.14038C6.78228 7.3509 6.51328 7.45617 6.18579 7.45617C5.87 7.45617 5.601 7.3509 5.37877 7.14038L0.484037 2.24564C0.285206 2.0585 0.185791 1.82459 0.185791 1.54388C0.185791 1.26318 0.285206 1.02926 0.484037 0.842131C0.682867 0.6433 0.916785 0.543884 1.18579 0.543884C1.47819 0.543884 1.71211 0.6433 1.88755 0.842131L6.78228 5.73687C6.84076 5.79535 6.75304 5.83628 6.51912 5.85967C6.2969 5.88307 6.06883 5.88307 5.83491 5.85967C5.61269 5.83628 5.53082 5.79535 5.5893 5.73687L10.484 0.842131Z' fill='#F5FAFF' />
                    </svg>
                  </div>
                </Button>
              </>
            ) : (
              <>
                <Button color='inherit' className='Header-Profile' onClick={toggleProfileModal}>
                  <div className='profile-icon'>
                    {cur_user.basics?.firstName[0]}{cur_user.basics?.lastName[0]}
                  </div>
                  <div className='profile-metadata'>
                    <div className='profile-name'>
                      {cur_user.basics?.firstName} {cur_user.basics?.lastName}
                    </div>
                    <div className='profile-email'>
                      {cur_user.basics?.email}
                    </div>
                  </div>
                  <div className='profile-open'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'>
                      <path d='M1.70175 7.15793C1.51462 7.35676 1.2807 7.45618 1 7.45618C0.719297 7.45618 0.48538 7.35676 0.298246 7.15793C0.0994158 6.9708 6.2883e-08 6.73688 8.74228e-08 6.45618C1.11962e-07 6.17547 0.0994159 5.94156 0.298247 5.75442L5.19298 0.859685C5.40351 0.649159 5.67252 0.543895 6 0.543895C6.31579 0.543895 6.5848 0.649159 6.80702 0.859685L11.7018 5.75442C11.9006 5.94156 12 6.17548 12 6.45618C12 6.73688 11.9006 6.9708 11.7018 7.15793C11.5029 7.35676 11.269 7.45618 11 7.45618C10.7076 7.45618 10.4737 7.35676 10.2982 7.15793L5.40351 2.26319C5.34503 2.20471 5.43275 2.16378 5.66667 2.14039C5.88889 2.117 6.11696 2.117 6.35088 2.14039C6.5731 2.16378 6.65497 2.20471 6.59649 2.26319L1.70175 7.15793Z' fill='#F5FAFF'/>
                    </svg>
                  </div>
                </Button>
                <div className='profile-modal'>
                  <div className='profile-tab'>
                    <div>
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M15.75 10.5H15V5.25C15 4.65326 14.7629 4.08097 14.341 3.65901C13.919 3.23705 13.3467 3 12.75 3H5.25C4.65326 3 4.08097 3.23705 3.65901 3.65901C3.23705 4.08097 3 4.65326 3 5.25V10.5H2.25C2.05109 10.5 1.86032 10.579 1.71967 10.7197C1.57902 10.8603 1.5 11.0511 1.5 11.25V12.75C1.5 13.3467 1.73705 13.919 2.15901 14.341C2.58097 14.7629 3.15326 15 3.75 15H14.25C14.8467 15 15.419 14.7629 15.841 14.341C16.2629 13.919 16.5 13.3467 16.5 12.75V11.25C16.5 11.0511 16.421 10.8603 16.2803 10.7197C16.1397 10.579 15.9489 10.5 15.75 10.5ZM4.5 5.25C4.5 5.05109 4.57902 4.86032 4.71967 4.71967C4.86032 4.57902 5.05109 4.5 5.25 4.5H12.75C12.9489 4.5 13.1397 4.57902 13.2803 4.71967C13.421 4.86032 13.5 5.05109 13.5 5.25V10.5H4.5V5.25ZM15 12.75C15 12.9489 14.921 13.1397 14.7803 13.2803C14.6397 13.421 14.4489 13.5 14.25 13.5H3.75C3.55109 13.5 3.36032 13.421 3.21967 13.2803C3.07902 13.1397 3 12.9489 3 12.75V12H15V12.75Z' fill='#BDBEC1'/>
                      </svg>
                    </div>
                    <div className='profile-tab-text'>
                      Workspace
                    </div>
                  </div>
                  <SnackbarProvider maxSnack={1}>
                    <TeamPicker />
                  </SnackbarProvider>
                  <svg xmlns='http://www.w3.org/2000/svg' width='240' height='2' viewBox='0 0 250 2' fill='none'>
                    <path d='M1 1H249' stroke='#4F525A' strokeLinecap='round'/>
                  </svg>
                  <div className='profile-tab' style={{ cursor: 'pointer' }} onClick={() => {
                    handleHomeRedirect();
                    KeycloakService.doLogout();
                  }}>
                    <div>
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M3 9C3 9.19891 3.07902 9.38968 3.21967 9.53033C3.36032 9.67098 3.55109 9.75 3.75 9.75H9.4425L7.7175 11.4675C7.6472 11.5372 7.59141 11.6202 7.55333 11.7116C7.51525 11.803 7.49565 11.901 7.49565 12C7.49565 12.099 7.51525 12.197 7.55333 12.2884C7.59141 12.3798 7.6472 12.4628 7.7175 12.5325C7.78722 12.6028 7.87017 12.6586 7.96157 12.6967C8.05296 12.7347 8.15099 12.7543 8.25 12.7543C8.34901 12.7543 8.44704 12.7347 8.53843 12.6967C8.62983 12.6586 8.71278 12.6028 8.7825 12.5325L11.7825 9.5325C11.8508 9.46117 11.9043 9.37706 11.94 9.285C12.015 9.1024 12.015 8.8976 11.94 8.715C11.9043 8.62294 11.8508 8.53883 11.7825 8.4675L8.7825 5.4675C8.71257 5.39757 8.62955 5.3421 8.53819 5.30426C8.44682 5.26641 8.34889 5.24693 8.25 5.24693C8.15111 5.24693 8.05318 5.26641 7.96181 5.30426C7.87045 5.3421 7.78743 5.39757 7.7175 5.4675C7.64757 5.53743 7.5921 5.62045 7.55426 5.71181C7.51641 5.80318 7.49693 5.90111 7.49693 6C7.49693 6.09889 7.51641 6.19682 7.55426 6.28819C7.5921 6.37955 7.64757 6.46257 7.7175 6.5325L9.4425 8.25H3.75C3.55109 8.25 3.36032 8.32902 3.21967 8.46967C3.07902 8.61032 3 8.80109 3 9ZM12.75 1.5H5.25C4.65326 1.5 4.08097 1.73705 3.65901 2.15901C3.23705 2.58097 3 3.15326 3 3.75V6C3 6.19891 3.07902 6.38968 3.21967 6.53033C3.36032 6.67098 3.55109 6.75 3.75 6.75C3.94891 6.75 4.13968 6.67098 4.28033 6.53033C4.42098 6.38968 4.5 6.19891 4.5 6V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H12.75C12.9489 3 13.1397 3.07902 13.2803 3.21967C13.421 3.36032 13.5 3.55109 13.5 3.75V14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H5.25C5.05109 15 4.86032 14.921 4.71967 14.7803C4.57902 14.6397 4.5 14.4489 4.5 14.25V12C4.5 11.8011 4.42098 11.6103 4.28033 11.4697C4.13968 11.329 3.94891 11.25 3.75 11.25C3.55109 11.25 3.36032 11.329 3.21967 11.4697C3.07902 11.6103 3 11.8011 3 12V14.25C3 14.8467 3.23705 15.419 3.65901 15.841C4.08097 16.2629 4.65326 16.5 5.25 16.5H12.75C13.3467 16.5 13.919 16.2629 14.341 15.841C14.7629 15.419 15 14.8467 15 14.25V3.75C15 3.15326 14.7629 2.58097 14.341 2.15901C13.919 1.73705 13.3467 1.5 12.75 1.5Z' fill='#BDBEC1'/>
                      </svg>
                    </div>
                    <div className='profile-tab-text'>
                      Logout
                    </div>
                  </div>
                </div>
              </>
            )}
          </li>
        </ul>
      </Toolbar>
    </AppBar>
  </>;
};

export default Header;
